import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { PurchasePartyModel } from '../model/index';
@Injectable()
export class PurchasePartyService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private purPartyUrl = 'api/purchaseParty';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getPurchasePartyList(query: any): Promise<PurchasePartyModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purPartyUrl}/purchasePartyList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deletePurchaseParty(rowData: any): Promise<PurchasePartyModel> {
       const url = `${this.purPartyUrl}/deletePurchaseParty`;
       return this.http
           .post(url, $.param(rowData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as PurchasePartyModel)
           .catch(this.handleError);
   }

   addUpdatePurchaseParty(purPartyData: any): Promise<PurchasePartyModel> {

       const url = `${this.purPartyUrl}/addUpdatePurchaseParty`;

       return this.http
           .post(url, $.param(purPartyData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as PurchasePartyModel)
           .catch(this.handleError);
   }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/purchaseParty.service.ts